import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { LookupGridComponent } from '@farris/ui-lookup';
import { MessagerService } from '@farris/ui-messager';
import { WfTaskHandlerService } from '@gsp-wf/wf-task-handler';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-release-component',
  templateUrl: './release-component.component.html',
  styleUrls: ['./release-component.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class ReleaseComponent implements OnInit {
  @ViewChild('buttonRef') btnRef: TemplateRef<any>;

  applicantName: string;
  applicantDepartment: string;
  @Input()
  procName: any;
  @Input()
  procVersion: number;
  @Input()
  processDefinitionKey: string;
  @ViewChild('lookup') public lookUp: LookupGridComponent;

  @Output() submit = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  session: string;
  accessLevel = 'public';
  organization;
  organizationName;
  textDetail;
  isAdministratorConfig = false;
  editor: any;

  administrator: any;
  dataUri = '/api/runtime/sys/v1.0/sysOrgs';
  applicantId: string;
  loadType = 'layerload';
  releaseType = 'release';
  items = new Array();
  releaseTypeList = [
    { value: 'release', name: this.localePipe.transform('component.release.release') },
    { value: 'update', name: this.localePipe.transform('component.release.update') },
  ];
  constructor(
    private uiState: ProcessDesignerUIState,
    private submitService: WfTaskHandlerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
    this.releaseType = this.procVersion === 1 ? 'release' : 'update';
    this.uiState.getUserInfo().subscribe(re => {
      this.applicantName = re.name;
      this.applicantDepartment = re.orgName;
      this.applicantId = re.id;
    });
  }

  saveAsOK() {
    this.uiState.createData().subscribe((saveData) => {
      const dataId = saveData.returnValue.id;
      const data = {
        DataId: dataId,
        applicantName: this.applicantName,
        applicantDepartment: this.applicantDepartment,
        procName: this.procName,
        procVersion: this.procVersion,
        releaseType: this.releaseType,
        textDetail: this.textDetail,
        processDefinitionKey: this.processDefinitionKey,
        applicantId: this.applicantId
      };
      const Info = {
        ChangeType: 'Modify',
        ChangeInfo: data
      };
      this.uiState.releaseSave(Info).subscribe((re) => {
        this.mySubmit(dataId, '03bdca37-8439-4924-8aef-20f3f4092b59');
        this.submit.next();
      });
    });
  }
  saveAsCancel() {
    this.cancel.emit();
  }
  editorCreated(quill) {
    const toolbar = quill.getModule('toolbar');
    this.editor = quill;
  }

  contentChanged(v) {
    console.log(v);
  }
  validator() {
    return true;
  }
  changeValue(data: any) {
    this.releaseType = data;
  }
  /**
   * 发布前审核：提交审批
   */
  private mySubmit(dataId: string, bizDefKey: string) {
    this.submitService.submitWithBizDefKey(dataId, bizDefKey);
  }
}
